import React from "react";
import { BaseView } from "./BaseView";
import InvestigationDetails from "../components/Investigations/InvestigationDetails";

const Investigation: React.FC = () => {
  return (
    <BaseView title={"Investigation"}>
      <div className="flex flex-col w-full h-full overflow-y-auto">
        <InvestigationDetails />
      </div>
    </BaseView>
  );
};

export default Investigation;